import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrokerService } from '../../services/broker/broker.service';

@Component({
  selector: 'app-claim-profile',
  templateUrl: './claim-profile.component.html',
  styleUrls: ['./claim-profile.component.scss']
})
export class ClaimProfileComponent implements OnInit {
  profileId = '';
  otp = '';
  loading = false;
  error = '';
  success = false;

  constructor(
    private brokerService: BrokerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.profileId = params['id'];
      }
    });
  }

  onSubmit(): void {
    this.error = '';
    if (!this.profileId || !this.otp) {
      this.error = 'Please enter both Profile ID and the 6-digit Handover OTP.';
      return;
    }

    this.loading = true;
    this.brokerService.verifyClaim(this.profileId, this.otp).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.status === 'success') {
          this.success = true;
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 3000);
        } else {
          this.error = res.message || 'Verification failed';
        }
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.message || 'Invalid or expired OTP code.';
      }
    });
  }
}
